import gql from "graphql-tag";

export const GEOCODE_DETAIL_FOR_MFE_QUERY = gql`
    query GeocodeDetailForMfe($PlaceId: String!, $searchType: String!, $geocodeType: String) {
        search {
            geocodeDetailForMfe(PlaceId: $PlaceId, searchType: $searchType, geocodeType: $geocodeType)
        }
    }
`;
